
import { Component, Prop, Vue } from 'vue-property-decorator'

import BankTransferModel from '../models/BankTransfer'

import { copyToClipboard } from 'quasar'
import EButton from './Button.vue'
import EPaymentInfo from './PaymentInfo.vue'

@Component({
  components: {
    EButton,
    EPaymentInfo,
  },
})
export default class BankTransfer extends Vue {
  @Prop({ required: true }) readonly bankTransfer!: BankTransferModel

  readonly hasPaymentCode = !!this.bankTransfer.paymentCode

  copied = false;

  async copyPaymentCode() {
    try {
      await copyToClipboard(this.bankTransfer.paymentCode)

      this.copied = true
      this.$emit('copy')
      setTimeout(() => { this.copied = false }, 1100)
    } catch (err) {
      console.error(err)
    }
  }

  openRedirectUrl() {
    window.open(this.bankTransfer.redirectUrl, '_blank')
  }

  private readonly messageHandler = (e: MessageEvent) => {
    const { paymentMethod, paymentToken } = e.data

    if (paymentMethod === 'BANK_TRANSFER' && paymentToken) {
      (e.source as Window)?.close()
      this.$emit('close')
    }
  }

  mounted() {
    if (this.bankTransfer.redirectUrl) {
      window.addEventListener('message', this.messageHandler)
      this.openRedirectUrl()
    }
  }

  beforeDestroy() {
    if (this.bankTransfer.redirectUrl) {
      window.removeEventListener('message', this.messageHandler)
    }
  }
}
